import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "@certn/forms/src/wrappers/withCascadiaControlProps";

import { ConsentFormDownloadControl as ConsentFormDownloadControlComponent } from "./ConsentFormDownloadControl";
import { useContext } from "react";
import { CascadiaJsonFormContext } from "@certn/forms";

function ConsentFormDownloadControl(props: CascadiaControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    // We don't render anything in the summary for consents.
    return null;
  }

  return <ConsentFormDownloadControlComponent {...props} />;
}

export const ConsentFormDownloadControlRenderer = withCascadiaControlProps(
  ConsentFormDownloadControl
);
